import { render, staticRenderFns } from "./SamplingStations.vue?vue&type=template&id=3c8939be"
import script from "./SamplingStations.vue?vue&type=script&lang=js"
export * from "./SamplingStations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports